import { AddonService } from 'types/AddonService';

export interface AddonServicesState {
    addonServices: Array<AddonService>;
    status: AddonServiceStatus;
    loading: boolean;
}

export enum AddonServiceStatus {
    Initial,

    Fetching,
    FetchSuccess,

    Error
}
